import { useState } from "react";
import PropTypes from "prop-types";
import { ChevronDown, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { formatDate } from "components/helpers";
import NoteContent from "components/NoteContent";

// The bodies a note had before its latest save, folded away. The activity log
// collapses a note to one row, so this is where the entries that grouping
// dropped are read.
function NoteVersions({ versions }) {
  const [open, setOpen] = useState(false);
  // An entry written before bodies were frozen onto them has no body to show.
  const readable = (versions ?? []).filter(version => version.note);

  if (readable.length === 0) {
    return null;
  }

  return (
    <div className="tw:mt-2 tw:border-t tw:border-[var(--color-border)] tw:pt-2">
      <Button
        variant="ghost"
        size="xs"
        aria-expanded={open}
        onClick={() => setOpen(shown => !shown)}
      >
        {open ? <ChevronDown /> : <ChevronRight />}
        {readable.length === 1
          ? "1 earlier version"
          : `${readable.length} earlier versions`}
      </Button>
      {open && (
        <div className="tw:mt-2 tw:flex tw:flex-col tw:gap-2">
          {readable.map(version => (
            <div
              key={version.id}
              className="tw:rounded-md tw:border tw:border-[var(--color-border)] tw:bg-[var(--color-background)] tw:px-3 tw:py-2"
            >
              <div className="tw:text-xs tw:text-[var(--color-text-muted)]">
                {version.user_name}
                {version.user_name && " · "}
                {formatDate(version.created_at)}
              </div>
              <NoteContent
                note={version.note}
                className="tw:mt-1 tw:max-h-96 tw:overflow-y-auto"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

NoteVersions.propTypes = {
  versions: PropTypes.arrayOf(PropTypes.object),
};

export default NoteVersions;
